export const DAYS = 3;

export const localizeKey = {
  1: 'orderExtensionOneDay',
  2: 'orderExtensionTwoDays',
  3: 'orderExtensionThreeDays',
};
